import styled from "styled-components";

const PromoCodeWrapper = styled.div`
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: #34c759 !important;
  }
  .switch-text {
    font-family: Bliss2;
    font-weight: 700;
    font-size: 16px;
    color: #4c565c;
    margin-top: 2px;
    margin-left: 10px;
  }
  .input-style {
    margin-top: 40px;
    .p-inputtext {
      background: #ffffff;
      border: 1px solid #6b47f5;
      height: 50px;
      border-radius: 5px;
      font-family: Bliss2;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      text-transform: capitalize;
    }
  }
  .input-style {
    margin-top: 40px;
    .p-inputtext {
      background: #ffffff;
      border: 1px solid #4f008c;
      height: 50px;
      border-radius: 5px;
      font-family: Bliss2;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      text-transform: capitalize;
    }
  }
  .p-button.p-button-warning {
    background: #6b47f5;
    border: 1px solid #6b47f5;
    border-radius: 5px;
    height: 50px;
    .p-button-label {
      font-family: Bliss2;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      text-transform: uppercase;
      color: #ffffff;
    }
  }
  .p-button.p-button-warning-stc {
    background: #4f008c;
    border: 1px solid #4f008c;
    border-radius: 5px;
    height: 50px;
    .p-button-label {
      font-family: Bliss2;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      text-transform: uppercase;
      color: #ffffff;
    }
  }
  .text-content {
    font-family: Bliss2;
    font-weight: 400;
    font-size: 13px;
    line-height: 17px;
    text-align: initial;
    margin-top: 16px;
    margin-bottom: 20px;
    color: #34a853;
  }

  .textColor .p-inputtext {
    color: #34a853 !important;
  }
  .round-style {
    position: absolute;
    top: 15px;
    right: 12px;
    background: #818b9b;
    color: #fff;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: pointer;
    span {
      position: relative;
      top: -4px;
    }
  }
  @media only screen and (max-width: 575.99px) {
    .main-div .col-md-4 {
      margin-left: 0px;
    }
    .ar {
      .p-inputtext {
        font-size: 14px !important;
      }
      .p-button.p-button-warning {
        height: 40px;
      }
    }
  }
`;

export default PromoCodeWrapper;
